// src/locales/en.js
export default {
    // Navbar Section
    navbar_home: "Home",
    navbar_services: "Services",
    navbar_blog: "Blog",
    navbar_about: "About",
    navbar_contact: "Contact",
    navbar_membership: "Join Now",

    // Home Screen (Hero Section)
    hero_title: `Start Your <span class="highlight">Journey</span>
                 <br>with <span class="with">HarashFit</span>`,
    hero_description: "All programs are science-based, fully customized, and personally delivered by Coach Bader Alheresh.",
    stat_1: "Customers",
    stat_2: "Years of Excellence",
    view_certifications: "View Certifications",

    // Home Screen (Services Section)
    services_heading_small: "Our Services",
    services_heading_big: `Best Services for a <span class="highlight">More <br> Active</span>, Healthy Life`,
    learn_more: "Learn More",

    // Home Screen (Latest Articles Section)
    latest_articles_title: `Latest <span class="thin">Articles</span>`,
    latest_articles_view_more: "View More",
    latest_articles_read_more: "More →",

    // Certifications Screen (Certifications Section)
    certifications_section: {
        title: "Certifications",
        cert_1_date: "Exp: 09/26/2026",
        cert_1_desc: "Certification for delivering professional personal training programs (NASM).",

        cert_2_date: "Completed: 01/02/2025",
        cert_2_desc: "Professional specialization in bodybuilding and physique transformation.",

        cert_3_date: "Completed: 01/16/2025",
        cert_3_desc: "Specialized in training women based on their physical and hormonal needs.",

        cert_4_date: "Completed: 01/18/2025",
        cert_4_desc: "Focus on safe, data-driven weight loss programs.",

        cert_5_date: "Completed: 10/08/2024",
        cert_5_desc: "Mental strength and discipline in training.",
    },

    // Services Screen (Services Section)
    services_hero_title: "Services",
    services_hero_text: `<span class="red">Transform</span> Your Body with the <span class="red">Best</span> Service!`,

    // Services Screen (Services Our Services Section)
    our_services_heading_small: "Our Services",
    our_services_heading_big: `Best Services for a <span class="highlight">More <br />Active</span>, Healthy Life`,
    our_services_description: "Discover personalized services designed to support your goals and elevate your lifestyle.",
    our_services_view_more: "View More",
    our_services_view_less: "View Less",
    our_services_learn_more: "Learn More",

    // Services Screen (Offer Section)
    stats_satisfied: "<span class='highlight'>Satisfied</span> customer",
    stats_trainer: "Professional <span class='highlight'>Trainer</span>",
    offer_heading: "Special <span class='highlight'>Discounts</span> & <br /><span class='highlight'>Promos</span>",
    offer_list: [
        {
            icon: "🔥",
            title: "Family Discount",
            description: "Train together as a family and save more! Get exclusive discounts when you sign up with two or more relatives.",
        },
        {
            icon: "🎓",
            title: "Student Discount",
            description: "Full-time student? Enjoy discounted training packages with valid student ID – because your fitness matters too!",
        },
        {
            icon: "🆕",
            title: "New Member Promotion",
            description: "First time here? Welcome! New members receive a special one-time offer on their first package. Start strong!",
        },
    ],

    // Services Screen (Memberships Section)
    membership_heading_small: "Membership Plans",
    membership_heading_big: `Unlimited <span class="highlight">Access</span> to the Fitness <br />You <span class="highlight">Want</span>!`,
    membership_order_now: "Order now",
    view_all_plans: "View All Plans",

    // Plans Screen (Plans Views Section)
    plans_view_plans_heading: "Subscription Plans",
    plans_view_plans_subheading: "Choose the plan that fits your goals",
    plans_view_monthly: "Monthly",
    plans_view_yearly: "Yearly",
    plans_view_one_time: "One-Time",
    plans_view_most_popular: "Most Popular",
    plans_view_order_now: "Order Now",


    // Service Details Screen (Service Details Section)
    service_details_subtitle: "Burn Fat, Build Healthy Habits!",
    service_details_benefits_title: "Benefits of this Program",
    service_details_operating_hours: "Operating hours",
    service_details_all_services: "All Services",
    service_details_membership_join: "Membership Join",
    service_details_join_name: "Your Name",
    service_details_join_email: "Your Email",
    service_details_join_phone: "Phone Number",
    service_details_join_plan: "Membership Plan",
    service_details_join_plan_basic: "Basic",
    service_details_join_plan_premium: "Premium",
    service_details_join_submit: "Join",

    // Blog Screen (Blog Section)
    blog_hero_title: "Blog Archive",
    blog_hero_text: `Get Knowledge, Get <span class="red">Results</span> – The Best Articles for Maximum <span class="red">Performance!</span>`,


    // Blogs Section (Blog Section)
    blogs_title_small: "Blogs",
    blogs_title_big: `Gain <span class="highlight">Knowledge</span>, Achieve Results – It's All Here!`,
    blogs_read_more: "More →",

    // Blog Post Screen (Blog Post Details Section)
    post_detail_why_title: "🔥 Why Is This {keyword} Effective?",
    post_detail_tips_title: "💡 Tips for Maximum Results",
    post_detail_note: "🔥 Ready to burn fat in just 30 minutes? Try these exercises today and feel the difference!",
    post_detail_sidebar_hours_title: "Operating hours",
    post_detail_sidebar_hours_1: "Saturday - Wednesday : 08:00AM - 5:00PM",
    post_detail_sidebar_hours_2: "Thursday : 08:00AM - 2:00PM",
    post_detail_sidebar_hours_3: "Friday : Closed",
    post_detail_sidebar_related: "Related Posts",

    // Blog Post Screen (Blog Post Question Section)
    contact_us_small: "Contact Us",
    contact_us_big: 'Still <span class="highlight">Have</span> Questions?',
    contact_phone: "Phone Number",
    contact_email: "E-mail",

    // About Screen (About Section)
    about_title: "About",
    about_subtitle: 'Transform Your <span class="red">Body</span>, Elevate Your <span class="red">Life!</span>',

    //About Screen (About Wcu Section)
    wcu_title: "Why <span class='highlight'>Choose</span> Me?",

    wcu_card_1_title: "<span class='highlight'>Commitment</span> to results",
    wcu_card_1_desc: "I don’t just promise — I deliver. Every plan I create is focused on helping you achieve real, lasting results.",

    wcu_card_2_title: "<span class='highlight'>Professional</span> & Certified Trainer",
    wcu_card_2_desc: "As a certified personal trainer, I bring experience, passion, and full support to help you reach your goals.",

    wcu_card_3_title: "<span class='highlight'>Programs</span> for All Levels",
    wcu_card_3_desc: "Whether you're a beginner or advanced, I’ll tailor a program that fits your level and pushes you forward.",

    // About Screen (About Certificates Section)
    certifications_heading: "My Certifications",
    certifications_text: "As a certified personal trainer, I hold several international certifications from NASM and other reputable institutions — ensuring you high-quality, safe, and effective training.",
    view_all_certifications: "View All Certifications",

    // About Screen (About Details Section
    about_detail_title_small: "About Us",
    about_detail_title_big: "Innovation Focused on Your <span class='highlight'>Comfort</span>",
    about_detail_paragraph: "With years of hands-on experience as a certified personal trainer (CPT), I specialize in weight loss, Bodybuilding training, and functional fitness. My mission is to empower individuals to achieve lasting results through tailored programs built around their unique goals and lifestyles. This isn’t just about workouts—it’s about building a stronger, healthier, and more confident version of you.",
    about_detail_stat_1: "Years of Excellence",
    about_detail_stat_2: "Members",
    about_detail_stat_3: "Weekly Classes",
    about_detail_stat_4: "Expert Trainer",
    about_detail_feature_1: "Expert Trainer",
    about_detail_feature_2: "Nutrition Guidance",
    about_detail_feature_3: "Premium Membership",
    about_detail_feature_4: "Progress Tracking",
    about_detail_feature_5: "Community Support",
    about_detail_feature_6: "Next-level",


    // Contact Screen (Contact Section)
    contact_hero_title: "Contact Us",
    contact_hero_paragraph: "We are ready to help you with Fitness <span class='red'>Principles!</span>",

    // Contact Screen (Contact Info Section)
    contact_info_location_title: "Our Location",
    contact_info_location_name: "HaarshFit",
    contact_info_location_address: "Tlaa Al-Ali, Amman, Jordan",

    contact_info_hours_title: "Operating Hours",
    contact_info_hours_weekdays: "Saturday - Wednesday : 08:00 AM - 5:00 PM",
    contact_info_hours_thursday: "Thursday : 08:00 AM - 2:00 PM",
    contact_info_hours_friday: "Friday : Closed",

    contact_info_contact_title: "Contact Us",

    contact_info_phone: "Phone Number: +962 7 9060 6181",
    contact_info_email: "Email : info{'@'}harashfit.com",

    contact_info_connect_title: "Connect With Us",

    // Contact Screen (Contact Send Section)
    contact_form_title: "Get In Touch",
    contact_form_name: "Your Name",
    contact_form_email: "Your Email",
    contact_form_phone: "Phone Number",
    contact_form_message: "Message",
    contact_form_send: "Send",

    // Footer Section
    footer_description: "Independent Fitness & Bodybuilding Coach — empowering clients through personalized training and real dedication.",
    footer_contact_us: "Contact Us",
    footer_phone: "Phone Number : +962 7 9060 6181",
    footer_email: "Email : info{'@'}harashfit.com",
    footer_links_title: "Quick Links",
    footer_link_services: "Services",
    footer_link_blog: "Blog Archive",
    footer_link_about: "About Us",
    footer_link_team: "Contact Us",
    footer_location_title: "Location",
    footer_location_address: "Tlaa Al-Ali, Amman, Jordan",
    footer_hours_title: "Operating Hours",
    footer_hours_1: "Saturday - Wednesday : 08:00AM - 5:00PM",
    footer_hours_2: "Thursday : 08:00AM - 2:00PM",
    footer_hours_3: "Friday : Closed",
    footer_privacy: "Privacy Policy",
    footer_terms: "Terms & Conditions",
    footer_cookies: "Cookie Policy",
    footer_impressum: "Impressum",
    footer_rights: "All rights reserved.",

    // Whatsapp Section
    whatsapp_section_tooltip: "Need help?",
    whatsapp_section_message: "Hello, I would like to inquire about your services",

    // Cookie Consent
    "cookie": {
        "message": "We use cookies to improve your experience.",
        "learn_more": "Learn more",
        "accept": "Accept",
        "reject": "Reject"
    }
};
